var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddressModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7747 5.88293C14.8282 1.82634 11.1955 0 8.00451 0C8.00451 0 8.00451 0 7.99549 0C4.81351 0 1.17181 1.81756 0.225333 5.87415C-0.829317 10.4049 2.01914 14.242 4.59717 16.6566C5.55267 17.5522 6.77859 18 8.00451 18C9.23042 18 10.4563 17.5522 11.4028 16.6566C13.9809 14.242 16.8293 10.4137 15.7747 5.88293ZM8.00451 10.282C6.43605 10.282 5.16506 9.0439 5.16506 7.5161C5.16506 5.98829 6.43605 4.75024 8.00451 4.75024C9.57296 4.75024 10.8439 5.98829 10.8439 7.5161C10.8439 9.0439 9.57296 10.282 8.00451 10.282Z",
    fill: "#009B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddressModal);
export default __webpack_public_path__ + "static/media/ic-address-modal.8652340922a6fa2d0d9175c95a48fcf7.svg";
export { ForwardRef as ReactComponent };